// extracted by mini-css-extract-plugin
module.exports = {"section":"ID3ntxV_zY","header":"_2wT2MIYUSA","notice":"QUplu8jSK8","reminder-inline":"otghSqh34Q"};